import EntityBase from '@/data/EntityBase';

export default class SwapShiftState extends EntityBase({
  updating: 0,
}) {}
